import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { APPLICATIONS_ERROR, CREATE_APPLICATION, CREATING_APPLICATION, GETTING_APPLICATIONS, GET_APPLICATIONS, UPDATED_APPLICATION, UPDATING_APPLICATION } from "../types"

export const createApplication = (applicationPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_APPLICATION,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/applications`, applicationPayload, { headers })
        
        dispatch({
            type: CREATE_APPLICATION,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: APPLICATIONS_ERROR,
            error
        })
    }
}

export const offerAdmission = (offerPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_APPLICATION,
            payload: true
        })
        const response = await axios.post(`${baseUrl}/admission-offers`, offerPayload, { headers })
        
        dispatch({
            type: UPDATED_APPLICATION,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: APPLICATIONS_ERROR,
            error
        })
    }
}

export const updateApplication = (applicationId, applicationPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_APPLICATION,
            payload: true
        })
        const response = await axios.patch(`${baseUrl}/applications/${applicationId}`, applicationPayload, { headers })
        
        dispatch({
            type: UPDATED_APPLICATION,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: APPLICATIONS_ERROR,
            error
        })
    }
}

export const updateApplicationExam = (applicationId, applicationPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_APPLICATION,
            payload: true
        })

        const response = await axios.patch(`${baseUrl}/applications/${applicationId}/update-exam`, applicationPayload, { headers })
        
        dispatch({
            type: UPDATED_APPLICATION,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: APPLICATIONS_ERROR,
            error
        })
    }
}

export const fetchApplications = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/applications?expand=admission,parent`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page > -1 && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage > -1 && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_APPLICATIONS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_APPLICATIONS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: APPLICATIONS_ERROR,
            error
        })
    }
}

export const clearCreatedApplication = () => async (dispatch) => { 
    dispatch({
        type: CREATE_APPLICATION,
        payload: null
    })
}

export const clearUpdatedApplication = () => async (dispatch) => { 
    dispatch({
        type: UPDATED_APPLICATION,
        payload: null
    })
}